/* ================================================================
   LegBilligt — TOP 10 LIGE NU

   Rangordenen er IKKE noget vi finder paa. Kollektionen er sorteret
   efter mest solgte i Shopify, og listen her tager bare de ti
   foerste i kollektionens egen raekkefoelge. Shopify regner den
   sortering ud selv, efterhaanden som der kommer ordrer, saa
   sektionen holder sig selv opdateret inden for netop den kategori
   (data-h) - ingen skal rette noget bagefter. Butikken har 0 ordrer
   endnu, saa i dag er de ti foerste et default; den dag der er
   ordrer, ER de ti mest solgte. Liquid viser kun sektionen paa de
   kollektioner hvor vi har bevist at sorteringen ER mest solgte -
   ellers ville overskriften lyve.

   KILDEN ER ?view=lager OG IKKE products.json (18-09).
   products.json ignorerer sidens filter og svarede i kollektionens
   egen BEST_SELLING-sortering, og med 0 ordrer laa de udsolgte
   forrest: side 1 af /collections/legetoej havde 0 koebbare varer ud
   af 250, saa listen blev filtreret helt tom, og sektionen stod
   blank paa en side der var fuld af varer. ?view=lager filtrerer paa
   serveren FOER sideopdelingen, saa de 50 paa foerste side alle kan
   koebes. Udsolgte varer og varer uden billede falder stadig ud, saa
   "top 10" betyder top 10 af det man kan koebe lige nu. Det er med
   vilje: en hitliste med en udsolgt vare paa foerstepladsen er
   ubrugelig. Eget lager og fjernlager taeller begge med - paa en
   kategoriside er det ligegyldigt hvor varen staar.

   Puljen deles med lb-auto.js gennem window.__lbPuljer, saa siden
   kun henter listen EN gang uanset hvor mange sektioner der bruger
   den. Begge filer SKAL derfor hente fra samme adresse.

   Billedbredde 380 — samme som de andre, saa CDN-cachen passer.
   Ingen MutationObserver.
   ================================================================ */
(function(){
  'use strict';

  var K = 'lb_onsker';
  var BRED = 380;
  var ANTAL = 10;
  var HJERTE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5S3.5 15 3.5 9.2A4.7 4.7 0 0 1 12 6.4a4.7 4.7 0 0 1 8.5 2.8c0 5.8-8.5 11.3-8.5 11.3z"/></svg>';

  var puljer = (window.__lbPuljer = window.__lbPuljer || {});
  var henter = (window.__lbHenter = window.__lbHenter || {});
  var sider  = (window.__lbSider  = window.__lbSider  || {});

  function laes(){ try { return JSON.parse(localStorage.getItem(K)) || []; } catch(e){ return []; } }
  function paaSedlen(h){ return laes().indexOf(h) > -1; }
  function kr(n){ return n.toFixed(2).replace('.', ',') + ' kr'; }

  /* ?view=lager leverer billedet med en bredde paa (width=640), hvor
     products.json leverede det uden. Saetter vi bare endnu et width=
     paa, staar der to i samme adresse, og CDN'et har ingen grund til
     at vaelge vores. Derfor rettes den der er, og ellers saettes en. */
  function lille(src, b){
    if(!src) return '';
    if(/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, '$1' + b);
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + b;
  }
  function k2af(p){
    var t = p.tags || [], i;
    for(i = 0; i < t.length; i++){
      if(String(t[i]).indexOf('k2-') === 0) return t[i];
    }
    return '';
  }

  function normaliser(p){
    var v = null, i;
    for(i = 0; i < p.variants.length; i++){
      if(p.variants[i].available){ v = p.variants[i]; break; }
    }
    if(!v) return null;
    var pris = parseFloat(v.price);
    if(!(pris > 0)) return null;
    var raa = (p.images && p.images[0]) ? p.images[0].src : '';
    if(!raa) return null;
    return { id: v.id, handle: p.handle, titel: p.title,
             url: '/products/' + p.handle, pris: pris,
             bil: lille(raa, BRED), flere: p.variants.length > 1,
             k2: k2af(p) };
  }

  /* Side 1 og kun side 1: raekkefoelgen ER rangordenen, og den maa
     ikke blandes. lb-auto.js henter flere sider ind bagefter, men
     laegger dem BAGEST, saa de foerste ti staar uroert. */
  function hentPulje(handle){
    if(puljer[handle]) return Promise.resolve(puljer[handle]);
    if(henter[handle]) return henter[handle];
    henter[handle] = fetch('/collections/' + handle + '?view=lager&filter.v.availability=1&page=1')
      .then(function(r){ return r.ok ? r.json() : {products:[]}; })
      .catch(function(){ return {products:[]}; })
      .then(function(d){
        var ud = [];
        (d.products || []).forEach(function(p){
          var n = normaliser(p);
          if(n) ud.push(n);
        });
        if(d.sider) sider[handle] = d.sider;
        puljer[handle] = ud;
        return ud;
      });
    return henter[handle];
  }

  function opdaterKurvIkon(){
    var boble = document.getElementById('cart-icon-bubble');
    if(!boble) return;
    fetch('/?sections=cart-icon-bubble')
      .then(function(r){ return r.json(); })
      .then(function(d){
        if(!d || !d['cart-icon-bubble']) return;
        var midl = document.createElement('div');
        midl.innerHTML = d['cart-icon-bubble'];
        var nyt = midl.querySelector('#cart-icon-bubble');
        boble.innerHTML = nyt ? nyt.innerHTML : d['cart-icon-bubble'];
      })
      .catch(function(){});
  }

  function iKurv(b, id){
    if(!b || b.disabled) return;
    var org = b.dataset.org || b.textContent;
    b.dataset.org = org;
    b.disabled = true;
    b.textContent = 'Lægger i kurv …';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
    .then(function(r){ return r.json(); })
    .then(function(svar){
      if(svar && svar.status && svar.status !== 200) throw new Error('fejl');
      opdaterKurvIkon();
      b.textContent = 'Lagt i kurven ✓';
      b.classList.add('ok');
      setTimeout(function(){
        b.textContent = org; b.classList.remove('ok'); b.disabled = false;
      }, 1800);
    })
    .catch(function(){
      b.textContent = 'Prøv igen';
      setTimeout(function(){ b.textContent = org; b.disabled = false; }, 1800);
    });
  }

  function tegn(rod, varer){
    var s = '', i, v;
    for(i = 0; i < varer.length; i++){
      v = varer[i];
      s += '<div class="lbtop-i">' +
             '<a class="lbtop-k" href="' + v.url + '">' +
               '<span class="lbtop-nr">' + (i + 1) + '</span>' +
               '<span class="lbtop-im" style="background-image:url(\'' + v.bil + '\')"></span>' +
             '</a>' +
             '<button type="button" class="lbo-hj' + (paaSedlen(v.handle) ? ' paa' : '') +
               '" data-h="' + v.handle + '" aria-label="Sæt på ønskesedlen">' + HJERTE + '</button>' +
             '<a class="lbtop-t" href="' + v.url + '">' + v.titel + '</a>' +
             '<div class="lbtop-pr">' + kr(v.pris) + '</div>' +
             (v.flere
               ? '<a class="lbtop-var" href="' + v.url + '">Vælg variant</a>'
               : '<button type="button" class="lbtop-kurv" data-v="' + v.id + '">Læg i kurv</button>') +
           '</div>';
    }
    rod.innerHTML = s;

    /* hjertet skal ligge OVEN PAA varen, ikke under den — men det er
       lettere at holde styr paa i markup naar det er et soskende. Vi
       flytter det ind i kortet bagefter. */
    rod.querySelectorAll('.lbtop-i').forEach(function(i2){
      var kort = i2.querySelector('.lbtop-k');
      var hj = i2.querySelector('.lbo-hj');
      if(kort && hj) kort.appendChild(hj);
    });

    rod.querySelectorAll('.lbtop-im').forEach(function(el){
      var url = (el.style.backgroundImage || '').slice(5, -2);
      var im = new Image();
      im.decoding = 'async';
      im.onload = function(){ el.classList.add('klar'); };
      im.onerror = function(){ el.classList.add('klar'); };
      im.src = url;
    });

    if(window.lbKortHjerter) window.lbKortHjerter();
  }

  function saet(rod){
    if(rod.dataset.klar) return;
    rod.dataset.klar = '1';
    var H = rod.dataset.h || '';
    rod.innerHTML = '<p class="lbtop-vent">Henter listen …</p>';
    hentPulje(H).then(function(pulje){
      if(pulje.length < 4){ rod.innerHTML = ''; return; }
      tegn(rod, pulje.slice(0, ANTAL));
    });
  }

  document.addEventListener('click', function(e){
    if(!e.target.closest) return;
    var b = e.target.closest('.lbtop-kurv');
    if(!b) return;
    e.preventDefault();
    iKurv(b, b.dataset.v);
  });

  function start(){ document.querySelectorAll('.lbtop').forEach(saet); }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();